import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';

// 懒加载页面组件
const Layout = lazy(() => import('./components/Layout'));
const Login = lazy(() => import('./pages/Login'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const TaskObservability = lazy(() => import('./pages/TaskObservability'));
const AsyncDispatch = lazy(() => import('./pages/AsyncDispatch'));
const ApiCallLogs = lazy(() => import('./pages/ApiCallLogs'));
const ApiKeys = lazy(() => import('./pages/ApiKeys'));
const IncomeStats = lazy(() => import('./pages/IncomeStats'));
const Announcements = lazy(() => import('./pages/Announcements'));

// 页面加载组件
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <LoadingSpinner size="lg" text="加载中..." />
  </div>
);

function App() {
  const { getCurrentUser, loading } = useAuthStore();

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<UserManagement />} />
                <Route path="tasks" element={<TaskObservability />} />
                <Route path="dispatches" element={<AsyncDispatch />} />
                <Route path="api-calls" element={<ApiCallLogs />} />
                <Route path="api-keys" element={<ApiKeys />} />
                <Route path="income" element={<IncomeStats />} />
                <Route path="announcements" element={<Announcements />} />
              </Route>
            </Routes>
          </Suspense>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
